//import { PageClosedIcon } from "cssReset/icon";
//import { useNavigate } from "react-router-dom";
import { MeasureHeader } from "style/measure";

interface PageProps {
  backPath: string;
}

const InspectResultHeader = ({ backPath }: PageProps) => {
  //const navigate = useNavigate();

  return (
    <MeasureHeader>
      <div className="closed-btn-box">
        {/*<button onClick={() => navigate(backPath)}>
          <div className="icon-box">
            <PageClosedIcon />
          </div>
        </button>*/}
      </div>
      <div className="header-title">
        <p>층간소음 간이검사 결과</p>
      </div>
    </MeasureHeader>
  );
};

export default InspectResultHeader;
